var map = {
	"./template.bet575": 677,
	"./template.bet575.tsx": 677,
	"./template.bet777": 411,
	"./template.bet777.tsx": 411,
	"./template.betbetbet": 678,
	"./template.betbetbet.tsx": 678,
	"./template.betblast": 679,
	"./template.betblast.tsx": 679,
	"./template.betgalaxy": 1735,
	"./template.betgalaxy.tsx": 1735,
	"./template.betprofessor": 680,
	"./template.betprofessor.tsx": 680,
	"./template.betroyale": 681,
	"./template.betroyale.tsx": 681,
	"./template.betstride": 682,
	"./template.betstride.tsx": 682,
	"./template.buffalobet": 683,
	"./template.buffalobet.tsx": 683,
	"./template.chromabet": 684,
	"./template.chromabet.tsx": 684,
	"./template.default": 700,
	"./template.default.tsx": 700,
	"./template.fiestabet": 685,
	"./template.fiestabet.tsx": 685,
	"./template.forsport": 686,
	"./template.forsport.tsx": 686,
	"./template.gigabet": 687,
	"./template.gigabet.tsx": 687,
	"./template.goldenbet888": 688,
	"./template.goldenbet888.tsx": 688,
	"./template.goldenrush": 689,
	"./template.goldenrush.tsx": 689,
	"./template.hyperbet": 690,
	"./template.hyperbet.tsx": 690,
	"./template.juicybet": 691,
	"./template.juicybet.tsx": 691,
	"./template.junglebet": 720,
	"./template.junglebet.tsx": 720,
	"./template.magnumbet": 692,
	"./template.magnumbet.tsx": 692,
	"./template.oldgill": 693,
	"./template.oldgill.tsx": 693,
	"./template.puntcity": 694,
	"./template.puntcity.tsx": 694,
	"./template.puntgenie": 695,
	"./template.puntgenie.tsx": 695,
	"./template.pyramidbet": 696,
	"./template.pyramidbet.tsx": 696,
	"./template.questbet": 697,
	"./template.questbet.tsx": 697,
	"./template.slambet": 698,
	"./template.slambet.tsx": 698,
	"./template.sterlingparker": 699,
	"./template.sterlingparker.tsx": 699,
	"./template.sugarcastle": 721,
	"./template.sugarcastle.tsx": 721,
	"./template.templebet": 1736,
	"./template.templebet.tsx": 1736,
	"./template.titanbet": 701,
	"./template.titanbet.tsx": 701,
	"./template.ts": 990,
	"./template.vikingbet": 702,
	"./template.vikingbet.tsx": 702,
	"./template.volcanobet": 703,
	"./template.volcanobet.tsx": 703,
	"./template.wellbet": 704,
	"./template.wellbet.tsx": 704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2471;